module.exports = __webpack_public_path__ + "img/5.f1378eaf.png";